var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXenieIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 342,
    height: 342,
    viewBox: "0 0 342 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1279_54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.078 176.442C271.078 176.442 271.012 176.338 270.974 176.286C270.987 176.286 270.987 176.274 270.987 176.248C271 176.312 271.051 176.364 271.078 176.43V176.442Z",
    fill: "url(#paint0_linear_1279_54)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.078 176.442C271.078 176.442 271.012 176.338 270.974 176.286C270.987 176.286 270.987 176.274 270.987 176.248C271 176.312 271.051 176.364 271.078 176.43V176.442Z",
    fill: "url(#paint1_linear_1279_54)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.078 176.442C271.078 176.442 271.012 176.338 270.974 176.286C270.987 176.286 270.987 176.274 270.987 176.248C271 176.312 271.051 176.364 271.078 176.43V176.442Z",
    fill: "url(#paint2_linear_1279_54)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.078 176.442C271.078 176.442 271.012 176.338 270.974 176.286C270.987 176.286 270.987 176.274 270.987 176.248C271 176.312 271.051 176.364 271.078 176.43V176.442Z",
    fill: "url(#paint3_linear_1279_54)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.149 2.0022C330.694 67.3362 307.918 127.447 270.998 176.238C270.998 176.251 270.998 176.275 270.986 176.275C253.453 199.466 232.691 220.089 209.412 237.48C208.012 238.537 206.588 239.594 205.152 240.614C154.542 277.115 92.4032 298.623 25.2307 298.623C17.1396 298.623 9.10985 298.303 1.16602 297.701V211.929C9.06073 212.789 17.0905 213.219 25.2307 213.219C77.1909 213.219 124.989 195.411 162.891 165.583C164.917 163.973 166.93 162.326 168.895 160.667C188.957 143.719 205.974 123.293 219.025 100.31C225.938 88.1432 231.746 75.251 236.289 61.8056V61.7687C242.697 42.842 246.639 22.8216 247.731 2.01449H333.149V2.0022Z",
    fill: "url(#paint4_linear_1279_54)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.021 83.4009C191.474 103.335 177.686 121.266 161.344 136.506C156.728 140.82 151.915 144.912 146.917 148.759C108.696 112.405 57.5952 89.4843 1.16602 87.5671V2.11426C55.8764 3.45387 107.051 19.0745 151.117 45.3874C169.398 56.301 186.44 69.0584 202.021 83.4009Z",
    fill: "url(#paint5_linear_1279_54)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.022 245.2V341.21C326.639 335.606 313.735 329.067 301.407 321.706C271.867 304.069 245.543 281.64 223.492 255.487C244.917 239.399 264.34 220.78 281.309 200.083C282.499 198.633 283.69 197.158 284.832 195.696C300.315 215.114 318.977 231.89 340.034 245.212L340.022 245.2Z",
    fill: "url(#paint6_linear_1279_54)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.078 176.442C271.078 176.442 271.012 176.338 270.974 176.286C270.987 176.286 270.987 176.274 270.987 176.248C271 176.312 271.051 176.364 271.078 176.43V176.442Z",
    fill: "url(#paint7_linear_1279_54)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1279_54",
    x1: 52.4279,
    y1: 330.37,
    x2: 329.155,
    y2: 135.781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6EE85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#8F85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC4375"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1279_54",
    x1: 52.4279,
    y1: 330.37,
    x2: 329.155,
    y2: 135.781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6EE85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#8F85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC4375"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1279_54",
    x1: 52.4279,
    y1: 330.37,
    x2: 329.155,
    y2: 135.781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6EE85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#8F85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC4375"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1279_54",
    x1: 52.4279,
    y1: 330.37,
    x2: 329.155,
    y2: 135.781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6EE85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#8F85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC4375"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1279_54",
    x1: -48.1071,
    y1: 316.086,
    x2: 412.666,
    y2: -26.5373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.130313,
    stopColor: "#A6EE85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#8F85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898167,
    stopColor: "#DC4375"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1279_54",
    x1: -48.3754,
    y1: 161.688,
    x2: 274.426,
    y2: -65.3162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#8F85FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1279_54",
    x1: 121.364,
    y1: 403.079,
    x2: 444.167,
    y2: 176.073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#8F85FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1279_54",
    x1: 52.4279,
    y1: 330.37,
    x2: 329.155,
    y2: 135.781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6EE85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#8F85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC4375"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1279_54"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 341,
    height: 341,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXenieIcon);
export default __webpack_public_path__ + "static/media/XenieIcon.e1ded27a1d1a371640a39d98e8b4c917.svg";
export { ForwardRef as ReactComponent };